import { onBeforeUnmount, onMounted } from 'vue'

type Refresh = () => void | Promise<void>

export function useVisibleRefresh(refresh: Refresh, intervalMs = 15_000): void {
  let timer: number | null = null
  let running = false

  const run = async (): Promise<void> => {
    if (running || (typeof document !== 'undefined' && document.hidden)) return
    running = true
    try {
      await refresh()
    } finally {
      running = false
    }
  }

  const start = (): void => {
    if (typeof window === 'undefined' || timer !== null) return
    timer = window.setInterval(() => void run(), intervalMs)
  }

  const stop = (): void => {
    if (typeof window === 'undefined' || timer === null) return
    window.clearInterval(timer)
    timer = null
  }

  const triggerRun = (): void => {
    void run()
  }

  const visibility = (): void => {
    if (document.hidden) {
      stop()
      return
    }
    start()
    void run()
  }

  onMounted(() => {
    start()
    document.addEventListener('visibilitychange', visibility)
    window.addEventListener('focus', triggerRun)
    window.addEventListener('online', triggerRun)
  })
  onBeforeUnmount(() => {
    stop()
    document.removeEventListener('visibilitychange', visibility)
    window.removeEventListener('focus', triggerRun)
    window.removeEventListener('online', triggerRun)
  })
}
